import type {CreateExtArgs, CreateExtensionArgument} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import {isBlocksEditor} from '../../../utils/appUtils'

export const footerMetadata = {
    canConnectToCode: (
        _createExtArgs: CreateExtArgs,
        _controllerRef: Pointer,
        createExtensionArgument?: CreateExtensionArgument
    ) => !isBlocksEditor(createExtensionArgument),
    fullWidth: true
}
